<template>
    <b-form-checkbox v-bind="$attrs" v-on="$listeners" class="keep-signed-in">
        {{ $t('label') }}
    </b-form-checkbox>
</template>

<script>
export default {
    name: 'CheckboxKeepMeLoggedIn',
    i18n: {
        messages: {
            'en-US': {
                label: 'Keep me logged in',
            },
            'es-ES': {
                label: 'Mantenerme conectado',
            },
            'pt-BR': {
                label: 'Continuar conectado',
            },
        },
    },
}
</script>

<style lang="scss">
.keep-signed-in {
    label {
        font-size: 1em;
        color: #65656e;
    }
}
</style>
